import { Component } from '@angular/core';

@Component({
  selector: 'master-layout',
  templateUrl: './master-layout.component.html'
})
export class  MasterLayoutComponent {
  
}
